import axios from "axios";

const API_URL = process.env.NEXT_PUBLIC_API_URL;


/**
 * Singleton axios instance*/
export const apiClient = axios.create({
  baseURL: API_URL + "/api/v1/",
  // Fail fast instead of hanging when the backend stalls (previously a dead
  // socket could block a request ~57s before ECONNRESET).
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  validateStatus: (status) => status < 500,
});

// Add a request interceptor to automatically append context parameters
apiClient.interceptors.request.use(async (config) => {
  let franchiseeId = null;
  let lang = null;

  // 1. Determine environment and extract context
  if (typeof window === "undefined") {
    // SERVER-SIDE: Read from headers injected by middleware
    try {
      const { headers } = await import("next/headers");
      const headersList = await headers();
      franchiseeId = headersList.get("x-franchisee-id");
      lang = headersList.get("x-lang");
    } catch (e) {
      // Quietly continue if headers are unavailable
    }
  } else {
    // CLIENT-SIDE: Read from URL search params
    const params = new URLSearchParams(window.location.search);
    franchiseeId = params.get("franchiseeId");
    lang = params.get("lang");
  }

  // 2. Append to query parameters if not already present
  // We sanitize here too as a final safety layer
  if (!config.params) config.params = {};

  // Handle explicit "default" language request to prevent backend errors
  if (config.params.lang === "default") {
    delete config.params.lang;
    delete config.params.language;
    lang = null;
  }

  if (franchiseeId && !config.params.franchiseeId) {
    config.params.franchiseeId = franchiseeId.split(/[?&]/)[0];
  }

  if (lang && !config.params.lang) {
    const cleanLang = lang.split(/[?&]/)[0];
    if (cleanLang !== "default") {
      config.params.lang = cleanLang;
      // Also inject 'language' key for endpoints that expect it (like Activities/Workshops)
      config.params.language = cleanLang;
    }
  }

  return config;
});